import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { Card, Button, Alert, Col, Form, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faCopy } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { parseData } from 'helpers/utils';
import axios from 'axios';
import * as formik from 'formik';
import { errorHandler } from 'helpers/response-utils';
import { validationSchmaForCreateFeePayerWallet } from 'static/validations/FeePayerWallet';
import * as yup from 'yup';
import { toast } from 'react-toastify';
// import QRCode from 'qrcode.react';

const Create = () => {
  const nav = useNavigate();
  const { Formik } = formik;
  const userJSON = localStorage.getItem('user');
  const token = localStorage.getItem('token');

  const [wallet, setWallet] = useState({
    name: '',
    description: ''
  });

  const schema = yup.object().shape(validationSchmaForCreateFeePayerWallet);

  const onSubmit = async (values: any) => {
    const data = {
      name: values.name,
      description: values.description
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/feepayer-wallet`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (response.data.status === 'error') {
        toast.error(response.data.error.message);
        return;
      }

      if (response.data.status === 'success') {
        toast.success(response.data.message);
      }

      nav('/feepayer-wallet/list');
    } catch (error) {
      console.error('Error occurred:', error);
    }
  };

  return (
    <Card className="col-6">
      <Card.Header>
        <div className="d-sm-flex justify-content-between">
          <h2>Fee Payer Wallet</h2>
        </div>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col xl={12}>
            <Formik
              validationSchema={schema}
              onSubmit={values => onSubmit(values)}
              initialValues={wallet}
            >
              {({
                handleSubmit,
                handleChange,
                values,
                touched,
                errors,
                setValues
              }) => {
                return (
                  <Form noValidate onSubmit={handleSubmit}>
                    <Row className={classNames('g-3', 'mb-6')}>
                      <Col sm={12} md={12}>
                        <Form.Group className="mb-2">
                          <Form.Label>Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            isValid={touched.name && !errors.name}
                            isInvalid={touched.name && !!errors.name}
                          />
                          <Form.Control.Feedback type="invalid">
                            {' '}
                            {errors.name}{' '}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      {/* <Col sm={3} md={3}>
                        <a href={qrCodeImage} download={values.code}>
                          <img src={qrCodeImage} alt="" className="w-50" />
                        </a>
                      </Col> */}

                      <Col sm={12} md={12}>
                        <Form.Group className="mb-2">
                          <Form.Label>Notes</Form.Label>
                          <Form.Control
                            as="textarea"
                            name="description"
                            value={values.description}
                            onChange={handleChange}
                            rows={4}
                          />
                        </Form.Group>
                      </Col>

                      <div className="text-end">
                        <Button type="submit" variant="primary">
                          Create
                        </Button>
                      </div>
                    </Row>
                  </Form>
                );
              }}
            </Formik>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Create;
